import React from "react";
import AtlasProductInfo from "components/Product-Info-Pages/Atlas/AtlasProductInfo";

const Atlas = () => <AtlasProductInfo />;

export default Atlas;
